import { THREE_MINS } from '../constants'
/**
 * Dev Note: Be sure to update the Session class in /client/src/app/app_services/utilities/session.ts
 * These are copy pasta until code is shared
 */
export class Session {
  private static _instance: Session
  private _interval?: ReturnType<typeof setInterval>

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public static get instance(): Session {
    if (!Session._instance) {
      Session._instance = new Session()
    }
    return Session._instance
  }

  public checkCookie() {
    const cookie = this._parseSessionCookie(document.cookie)
    /**
     * the cookie didn't exist, we don't want to log the user out.
     * Instead, we want to fall back to the original experience where
     * the user will have the legacy experience of a silent session expiration (server side)
     */
    if (!cookie || !Array.isArray(cookie)) return
    const [cookieName, cookieValue] = cookie
    /**
     * might be overly defensive - previous check should handle this, but just in case.
     * We want to be extra sure that a logout isn't the default behavior if we didn't parse
     * the cookie
     */
    if (!cookieName) return

    const timeRemaining = this._getTimeRemaining(cookieValue)
    if (!cookieValue || timeRemaining < 0) {
      // we are on a public route (no user session)
      document.dispatchEvent(new Event('ensureSessionLoggedOut'))
      return
    }
    if (timeRemaining < THREE_MINS) {
      // we are in the time out window
      document.dispatchEvent(new Event('ensureSessionModalOpen'))
      return
    }

    if (timeRemaining > THREE_MINS) {
      // we are outside of the timeout window
      document.dispatchEvent(new Event('ensureSessionModalClosed'))
      return
    }
  }

  public pollCookie() {
    if (this._interval) {
      clearInterval(this._interval)
    }
    this._interval = setInterval(this.checkCookie.bind(this), 1000)
  }

  public cancelPoll() {
    if (this._interval) {
      clearInterval(this._interval)
    }
  }

  private _parseSessionCookie(cookie: string): Array<string> | undefined {
    const cookies = cookie.split(';')
    const sessionCookie = cookies?.find(row => row.trim().startsWith('session-expiration'))
    const sessionCookieParts = sessionCookie?.split('=')
    return sessionCookieParts
  }

  private _getTimeRemaining(dateString: string): number {
    return new Date(dateString).getTime() - Date.now()
  }
}

export default Session.instance
